'use client';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { openWindow } from '@/redux/slice/windowSlice';
import { RootState } from '@/redux/store';
import { WindowData } from '@/utils/types/window';
import Image from 'next/image';
import { memo, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const OpenWindowsMenu = () => {
  const dispatch = useDispatch();
  const windows = useSelector((state: RootState) => state.windows.windows);
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const hiddenWindows = windows.filter((w: WindowData) => !w.isWindowOpen);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);
  const handleOpen = (win: WindowData) => {
    dispatch(openWindow({
      title: win.title,
      componentKey: win.componentKey,
      id: win.id
    }));
    setIsOpen(false);
  };
  return <div ref={containerRef} className="relative" data-sentry-component="OpenWindowsMenu" data-sentry-source-file="OpenWindowsMenu.tsx">
      <TooltipProvider data-sentry-element="TooltipProvider" data-sentry-source-file="OpenWindowsMenu.tsx">
        <Tooltip data-sentry-element="Tooltip" data-sentry-source-file="OpenWindowsMenu.tsx">
          <TooltipTrigger asChild data-sentry-element="TooltipTrigger" data-sentry-source-file="OpenWindowsMenu.tsx">
            <button type="button" aria-label="Show Open Windows" onClick={() => setIsOpen(prev => !prev)} className="flex h-8 w-8 items-center justify-center rounded-[8px] bg-white/85 shadow-sm hover:bg-white">
              <Image src="/images/waffle-icon.svg" alt="Show Open Windows" width={18} height={18} className="h-[18px] w-[18px]" data-sentry-element="Image" data-sentry-source-file="OpenWindowsMenu.tsx" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="bottom" align="start" collisionPadding={12} data-sentry-element="TooltipContent" data-sentry-source-file="OpenWindowsMenu.tsx">
            <p>Show Open Windows</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      {isOpen && <div className="absolute left-0 top-[40px] z-50 flex max-h-[300px] min-w-[180px] flex-col gap-y-2 overflow-x-auto rounded-sm border border-[#ddd] bg-[rgba(255,255,255,0.95)] px-4 py-3 shadow-lg backdrop-blur-md">
          {hiddenWindows.length ? hiddenWindows.map(win => <button key={win.id} onClick={() => handleOpen(win)} className="flex min-w-[125px] flex-col items-center justify-center gap-y-1 rounded-[8px] bg-[#d5d5d578] px-3 py-2 text-xs font-semibold hover:bg-[#fff]">
                <span className="text-xs text-[#2e2e2e]">{win.title}</span>
              </button>) : <p className="min-w-[125px] text-sm text-[#2e2e2e]">No hidden windows</p>}
        </div>}
    </div>;
};
export default memo(OpenWindowsMenu);